import React, { useState } from 'react';
import { Container, makeStyles, AppBar, Tabs, Tab } from '@material-ui/core';
import TabPanel from '../ui_components/tab_panel';
import DailyReportsList from './daily_reports/daily_reports_list';
import WorkerReportsList from './worker_reports/worker_reports_list';
import YearlyReportsList from './yearly_reports/yearly_reports_list';
import GraphAnalytics from './graph_analytics/graph_analytics';

const useStyles = makeStyles((theme) => ({
    container: {
        flexGrow: 1,
        width: '100%',
		padding: theme.spacing(3, 2),
        justifyContent: 'center',
        maxWidth: 'none'
	},
    appBar: {
        backgroundColor: theme.palette.background.paper,
        minHeight: 600
    },
    tabs: {
        minWidth: 150
    },
    tab: {
        marginRight: theme.spacing(3)
    },
    tabPanel: {
        width: '100%'
    },
    root: {
        justifyContent: 'center'
    },
    scroller: {
        flexGrow: 0
    }
}));

function a11yProps(index) {
    return {
        id: `scrollable-auto-tab-${index}`,
        'aria-controls': `scrollable-auto-tabpanel-${index}`
    };
}

const ReportsTabs = () => {
    const { container, appBar, tabs, tab, tabPanel, root, scroller } = useStyles();
    const [value, setValue] = useState(0);

    const handleChangeValue = (e, newValue) => {
        setValue(newValue);
    }

    return (
        <Container className={container}>
            <AppBar className={appBar} position="static" color="default">
                <Tabs
                    classes={{ root, scroller }}
                    className={tabs}
                    value={value}
                    onChange={handleChangeValue}
                    indicatorColor="primary"
                    textColor="primary"
                    variant="scrollable"
                    scrollButtons="auto"
                    aria-label="scrollable auto tabs"
                >
                    <Tab label="Dnevni izveštaji" {...a11yProps(0)} className={tab} />
                    <Tab label="Izveštaji po radnicima" {...a11yProps(1)} className={tab} />
                    <Tab label="Godišnji izveštaj" {...a11yProps(2)} className={tab} />
                    <Tab label="Analitika" {...a11yProps(3)} className={tab} />
                </Tabs>
                <TabPanel value={value} index={0} className={tabPanel}>
                    <DailyReportsList />
                </TabPanel>
                <TabPanel value={value} index={1} className={tabPanel}>
                    <WorkerReportsList />
                </TabPanel>
                <TabPanel value={value} index={2} className={tabPanel}>
                    <YearlyReportsList />
                </TabPanel>
                <TabPanel value={value} index={3} className={tabPanel}>
                    <GraphAnalytics />
                </TabPanel>
            </AppBar>
        </Container>
    )
}

export default ReportsTabs;
